import { RouteObject } from 'react-router-dom';

import { Login } from './Login';

export const loginRoute: RouteObject = {
  path: 'login',
  element: <Login />,
};